.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: scroll;

  .in-product-buy-main-container {
    display: block;
  }

  .in-product-buy-loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  .in-product-buy-error-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  // loading state
  &.is-loading {
    .in-product-buy-main-container {
      display: none;
    }

    .in-product-buy-loading-container {
      display: flex;
    }
  }

  //error state
  &.is-error {
    .in-product-buy-main-container {
      display: none;
    }

    .in-product-buy-error-container {
      display: flex;
    }
  }
}
